export const getCourseList = (payload?: any) => ({
    type: "@saga/GET_COURSE_LIST",
    payload
});

